import { InjectionToken } from '@angular/core';
import { ScConfiguration } from '../interfaces/sc-configuration';

export const SC_CONFIGURATION = new InjectionToken<ScConfiguration>(
  'Konfigurace pro selfcare'
);
